<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Edit Document</h4>
    </div>
    <div v-if="document" class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            placeholder="Please Select"
            v-model="form.type"
            label="Document Type"
            :options="types"
            :required="true"
            :show-error="form.errors.has('type')"
            helper="Please select a document type to upload"
            :error-message="form.errors.get('type')"
            key-name="identifier"
          ></selectlist>
          <input-block
            name="description"
            label="Description"
            v-model="form.description"
            helper="Please enter a description for the document you are adding"
          ></input-block>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="editDocument"
        >Update Document</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      required: true
    },
    document: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      form: new window.Form({
        type: null,
        description: null
      })
    };
  },

  methods: {
    closeModal() {
      this.form.reset();
      this.$emit('close');
    },

    editDocument() {
      this.form
        .put(
          `/incidents/${this.incident}/documents/${this.document.identifier}`
        )
        .then(response => {
          this.$emit('edited', response);
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'Oops, there was an error updating the document'
          );
        });
    }
  },
  watch: {
    show(val) {
      if (val && this.document) {
        this.form.type = this.document.type
          ? this.document.type.identifier
          : null;
        this.form.description = this.document.description;
      }
    }
  }
};
</script>
